import initialState from './initialState';
import { reducer as getCountersReducer} from './getCounters'
import { reducer as forceCatalogRefreshReducer } from './forceCatalogRefresh'
import { LOGOUT_USER } from '../../common/redux/constants'

const reducers = [
  getCountersReducer,
  forceCatalogRefreshReducer
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
